module.exports = __webpack_public_path__ + "44d9e90bd6e402b81a446014be469410.svg";